import { theme as defaultTheme, Spinner, Button } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import CustomModal from "components/lib/customModal";
import { Row } from "components/lib/customModal/customModal.styles";
import { Typography } from "components/typography";

// TODO: refactor, this is almost the same modal as assign icbt

export const RowCenter = styled(Row)`
  justify-content: center;
  align-items: baseline;
  gap: 10px;
`;

// TODO: fix, this is also in assign icbt confirm modal
const ModalTopMarginFixWrapper = styled.div`
  margin-top: -10px;
`; // Custom modal wrapper has some stupid hard coded defaults

export const ConfirmRemoveAssignModal = ({
  setModalIsOpen,
  open,
  handleRemove,
  isSubmitting,
  patientName,
}: {
  setModalIsOpen: (arg: boolean) => void;
  open: boolean;
  handleRemove: () => Promise<void>;
  isSubmitting: boolean;
  patientName: string;
}) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    setModalIsOpen(false);
  };

  const handleAccept = async () => {
    await handleRemove();
    setModalIsOpen(false);
  };

  return (
    <CustomModal.Wrapper
      onClose={() => setModalIsOpen(false)}
      open={open}
      size="small"
      isScrollable={true}
    >
      <ModalTopMarginFixWrapper>
        <Typography
          variant="h3"
          sx={{ textAlign: "center" }}
          dataTestId="removeIcbtText"
        >
          {t("REMOVE_ASSIGN_CONFIRM", { patientName })}
        </Typography>
        <RowCenter>
          <Button
            variant="secondary"
            onClick={handleCancel}
            disabled={isSubmitting}
            testId="cancelButton_popup"
          >
            <Typography
              variant="body"
              sx={{ fontWeight: defaultTheme.FONT.WEIGHT.MEDIUM }}
            >
              {t("CANCEL")}
            </Typography>
          </Button>
          <Button
            variant="primary"
            onClick={handleAccept}
            disabled={isSubmitting}
            testId="removeButton_popup"
          >
            <Typography
              variant="body"
              sx={{ fontWeight: defaultTheme.FONT.WEIGHT.MEDIUM }}
            >
              {t("REMOVE")}
            </Typography>
          </Button>
        </RowCenter>
        {isSubmitting ? (
          <RowCenter>
            <Spinner />
          </RowCenter>
        ) : null}
      </ModalTopMarginFixWrapper>
    </CustomModal.Wrapper>
  );
};
